import { Fragment, useEffect, useState } from "react";
import WhyLanding from "./whyLanding/WhyLanding";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import ProvenToWork from "./proventowork/ProvenToWork";
import TitleBigridInfo from "../../components/titleBigridInfo/TitleBigridInfo";

import AllCompanies from "./allcompanies/AllCompanies";
import WOW from "wow.js";
import axios from "axios";
import { baseUrl, getServicePage } from "../../utils/apiData";
import LoaderCard from "../../components/loaderCard/LoaderCard";

const Services = () => {
  const [loader, setLoader] = useState(false);
  const [clients, setClients] = useState([]);
  const [servicePage, setServicePage] = useState({});

  // Service Page APi
  const getServicePageApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getServicePage}`);
      if (res?.data?.success) {
        setClients(res?.data?.data?.serviceclient);
        setServicePage(res?.data?.data?.servicepagedata);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    const wow = new WOW();
    wow.init();

    getServicePageApi();
  }, []);
  return (
    <Fragment>
      <PageLayout>
        {loader ? (
          <LoaderCard />
        ) : (
          <Fragment>
            <WhyLanding
              title={servicePage?.main_title || "-"}
              des={servicePage?.main_description || "-"}
              img={servicePage?.main_image}
            />
            {/* <ProvenToWork
              heading={servicePage?.section_1_heading || "-"}
              title={servicePage?.section_1_title || "-"}
            /> */}

            <TitleBigridInfo
              category=""
              theme="dark"
              title={servicePage?.section_2_title || "-"}
              des={servicePage?.section_2_description || "-"}
              img={servicePage?.section_2_image}
              clickHandler={() => {
              }}
            />

            <TitleBigridInfo
              theme="light"
              title={servicePage?.section_3_title || "-"}
              des={servicePage?.section_3_description || "-"}
              img={servicePage?.section_3_image}
              category={servicePage?.section_3_category || "-"}
              clickHandler={() => {
                console.log("clicked");
              }}
            />
            <AllCompanies 
            category={servicePage?.section_4_category|| "-"}
            title={servicePage?.section_4_title || "-"}
            clients={clients} />
          </Fragment>
        )}
      </PageLayout>
    </Fragment>
  );
};

export default Services;
